const CUSTOM_EVENTS = {
  TOGGLE_MENU: 'toggle_menu',
  SERVICE_LAUNCH_REQUEST: 'service_launch_request',
  SERVICE_COUNTRY_SELECTION_REQUESTED: 'service_country_selection_requested',
  SERVICE_COUNTRY_SELECTED: 'service_country_selected',
  THANK_YOU_PAGE_REQUIRED: 'thank_you_page_required',
  TRANSACTION_DETAILS_REQUESTED: 'transaction_details_requested',
  REQUEST_WITHDRAWAL_LAUNCHING: 'request_withdrawal_launching',
  PAYMENT_LINK_VIEWER_REQUESTED: 'payment_link_viewer_requested',
}

export { CUSTOM_EVENTS }
